import type { PlayerInspectionInput, PlayerInspectionResult } from '@/types';
import { ApiError } from '@/features/bet-inspection/lib/api';

/** POST {api}/player-inspection — per-player analytics + fraud signals. */
export async function fetchPlayerInspection(params: {
  api: string;
  token: string | null;
  input: PlayerInspectionInput;
  signal?: AbortSignal;
}): Promise<PlayerInspectionResult> {
  const base = params.api.replace(/\/+$/, '');

  let res: Response;
  try {
    res = await fetch(`${base}/player-inspection`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        ...(params.token ? { authorization: `Bearer ${params.token}` } : {}),
      },
      body: JSON.stringify(params.input),
      signal: params.signal,
    });
  } catch (err) {
    if ((err as Error)?.name === 'AbortError') throw err;
    throw new ApiError(`Could not reach the betlens API at ${base}.`, 0);
  }

  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as { error?: string } | null;
    throw new ApiError(body?.error ?? `Request failed (${res.status})`, res.status);
  }

  return (await res.json()) as PlayerInspectionResult;
}
